import { render, staticRenderFns } from "./TbPay.vue?vue&type=template&id=e98f2590&scoped=true"
import script from "./TbPay.vue?vue&type=script&lang=js"
export * from "./TbPay.vue?vue&type=script&lang=js"
import style0 from "./TbPay.vue?vue&type=style&index=0&id=e98f2590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98f2590",
  null
  
)

export default component.exports